<template>
  <div class="grid row">
    <div class="flex xs12">
      <va-card title="Редагування Quality" class="fill-height">
        <div>
          <div class="row">
            <div class="flex xs12">
              <va-tabs v-model="tabValue" style="width: 100%; min-width: 250px; margin-bottom: 25px;">
                <va-tab
                  v-for="title in tabTitles"
                  :key="title"
                >
                  {{title}}
                </va-tab>
              </va-tabs>
              <div class="flex xs12" v-if="tabValue === 0">
                <va-input
                  label="Label *"
                  v-model="label"
                  :messages="['The recommended number of characters is 255']"
                  @input="delete errors.label"
                  :error="!!errors.label"
                  :error-messages="errors.label"
                />
                <va-input
                  label="Content"
                  v-model="content"
                  type="textarea"
                  :messages="['The recommended number of characters is 500']"
                  @input="delete errors.content"
                  :error="!!errors.content"
                  :error-messages="errors.content"
                />
                <va-toggle label="Show in stage" small v-model="show_in_stage"/>
                <va-toggle label="Published" small v-model="published"/>
                <va-input
                  label="Position"
                  v-model.number="position"
                  @input="delete errors.position"
                  :error="!!errors.position"
                  :error-messages="errors.position"
                />
                <va-button @click="submit()">Save</va-button>
              </div>
            </div>
          </div>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import Vue from 'vue'

export default {
  name: 'grid',
  data () {
    return {
      label: '',
      content: '',
      position: '',
      show_in_stage: false,
      published: false,

      errors: [],

      tabTitles: ['Main'],
      tabValue: 0,
    }
  },
  created () {
    this.fetch()
  },
  computed: {
    computedStyle () {
      return {
        backgroundColor: this.$themes.primary,
      }
    },
    locale () {
      return Vue.i18n.locale()
    },
  },
  watch: {
    locale: function (value) {
      this.fetch()
    },
  },
  methods: {
    submit () {
      const data = {
        label: this.label,
        position: this.position,
        published: !!this.published,
        show_in_stage: !!this.show_in_stage,
        content: this.content,
      }
      if (this.$attrs.id) { // update
        axios.put(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/quality/${this.$attrs.id}`, data)
          .then(response => {
            this.$router.push({ name: 'autostrada-widgets-quality' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      } else {
        axios.post(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/quality`, data)
          .then(response => {
            this.$router.push({ name: 'autostrada-widgets-quality' })
            this.showToast('Success')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }
            console.log(error)
            this.showToast('Error')
          })
      }
    },
    fetch () {
      if (this.$attrs.id) {
        axios.get(`${process.env.VUE_APP_AUTOSTRADA_API_URL}/${this.locale}/admin/quality/${this.$attrs.id}`)
          .then(response => {
            console.log(response.data)
            this.label = response.data.label
            this.position = response.data.position
            this.published = !!response.data.published
            this.show_in_stage = !!response.data.show_in_stage
            this.content = response.data.content
          })
          .catch(error => {
            console.log(error)
            this.showToast('Error')
          })
      }
    },
  },
}
</script>

<style lang="scss">
.grid {
  &__container {
    min-height: 3rem;
    color: $white;
    border-radius: 0.5rem;
  }
}

.va-file-upload-gallery-item {
  flex-basis: unset;
  max-width: 400px;
  width: unset;
}
</style>
